import { render, staticRenderFns } from "./editBlock.vue?vue&type=template&id=5a8ac72f&"
import script from "./editBlock.vue?vue&type=script&lang=js&"
export * from "./editBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports